import * as ambassadorWixEcomV1DraftOrder from './ecom-v1-draft-order-draft-orders.http.js';
import * as ambassadorWixEcomV1DraftOrderTypes from './ecom-v1-draft-order-draft-orders.types.js';
import * as ambassadorWixEcomV1DraftOrderUniversalTypes from './ecom-v1-draft-order-draft-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDraftOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.CreateDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CreateDraftOrderResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CreateDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderTypes.CreateDraftOrderResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.createDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createEmptyDraftOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateEmptyDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.CreateEmptyDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateEmptyDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CreateEmptyDraftOrderResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CreateEmptyDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderTypes.CreateEmptyDraftOrderResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.createEmptyDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/create-empty-draft-order',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addLineItemsToDraftOrder(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.AddLineItemsToDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.AddLineItemsToDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.AddLineItemsToDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.AddLineItemsToDraftOrderResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.AddLineItemsToDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderTypes.AddLineItemsToDraftOrderResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.addLineItemsToDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/add-line-items',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLineItems(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.UpdateLineItemsRequest,
  ambassadorWixEcomV1DraftOrderTypes.UpdateLineItemsRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.UpdateLineItemsResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.UpdateLineItemsResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.UpdateLineItemsResponse &
    ambassadorWixEcomV1DraftOrderTypes.UpdateLineItemsResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.updateLineItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/line-items',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDiscounts(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetDiscountsRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetDiscountsRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetDiscountsResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetDiscountsResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetDiscountsResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetDiscountsResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1DraftOrder.setDiscounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/set-discounts',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCustomDiscounts(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomDiscountsRequest,
  ambassadorWixEcomV1DraftOrderTypes.CreateCustomDiscountsRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomDiscountsResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomDiscountsResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CreateCustomDiscountsResponse &
    ambassadorWixEcomV1DraftOrderTypes.CreateCustomDiscountsResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.createCustomDiscounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/create-custom-discounts',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCustomDiscounts(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomDiscountsRequest,
  ambassadorWixEcomV1DraftOrderTypes.DeleteCustomDiscountsRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomDiscountsResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomDiscountsResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.DeleteCustomDiscountsResponse &
    ambassadorWixEcomV1DraftOrderTypes.DeleteCustomDiscountsResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.deleteCustomDiscounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/delete-custom-discounts',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setAdditionalFees(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetAdditionalFeesResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetAdditionalFeesResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setAdditionalFees(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/set-additional-fees',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCustomAdditionalFees(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderTypes.CreateCustomAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CreateCustomAdditionalFeesResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CreateCustomAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderTypes.CreateCustomAdditionalFeesResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.createCustomAdditionalFees(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/create-additional-fees',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCustomAdditionalFees(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderTypes.DeleteCustomAdditionalFeesRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteCustomAdditionalFeesResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.DeleteCustomAdditionalFeesResponse &
    ambassadorWixEcomV1DraftOrderTypes.DeleteCustomAdditionalFeesResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.deleteCustomAdditionalFees(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/delete-custom-additional-fees',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setShippingInfo(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetShippingInfoRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetShippingInfoRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetShippingInfoResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetShippingInfoResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetShippingInfoResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetShippingInfoResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setShippingInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-shipping-info',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setBuyerInfo(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBuyerInfoRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetBuyerInfoRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBuyerInfoResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetBuyerInfoResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetBuyerInfoResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetBuyerInfoResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1DraftOrder.setBuyerInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-buyer-info',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setRecipientInfo(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetRecipientInfoRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetRecipientInfoRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetRecipientInfoResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetRecipientInfoResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetRecipientInfoResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetRecipientInfoResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setRecipientInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-recipient-info',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setBillingInfo(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBillingInfoRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetBillingInfoRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBillingInfoResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetBillingInfoResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetBillingInfoResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetBillingInfoResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setBillingInfo(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-billing-info',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDraftOrder(): __PublicMethodMetaInfo<
  'GET',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.GetDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.GetDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.GetDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.GetDraftOrderResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.GetDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderTypes.GetDraftOrderResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.getDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-orders/{draftOrderId}',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrderDraftabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  { orderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.GetOrderDraftabilityStatusRequest,
  ambassadorWixEcomV1DraftOrderTypes.GetOrderDraftabilityStatusRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.GetOrderDraftabilityStatusResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.GetOrderDraftabilityStatusResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.GetOrderDraftabilityStatusResponse &
    ambassadorWixEcomV1DraftOrderTypes.GetOrderDraftabilityStatusResponseNonNullableFields
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.getOrderDraftabilityStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/draft-orders/{orderId}/draftability',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function commitDraftOrder(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.CommitDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.CommitDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CommitDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CommitDraftOrderResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CommitDraftOrderResponse &
    ambassadorWixEcomV1DraftOrderTypes.CommitDraftOrderResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.commitDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/commit',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOrderFromDraft(): __PublicMethodMetaInfo<
  'POST',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateOrderFromDraftRequest,
  ambassadorWixEcomV1DraftOrderTypes.CreateOrderFromDraftRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.CreateOrderFromDraftResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.CreateOrderFromDraftResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.CreateOrderFromDraftResponse &
    ambassadorWixEcomV1DraftOrderTypes.CreateOrderFromDraftResponseNonNullableFields
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.createOrderFromDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/{draftOrderId}/create-order',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDraftOrder(): __PublicMethodMetaInfo<
  'DELETE',
  { draftOrderId: string },
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderTypes.DeleteDraftOrderRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.DeleteDraftOrderResponse,
  ambassadorWixEcomV1DraftOrderTypes.DeleteDraftOrderResponse
> {
  const payload = { draftOrderId: ':draftOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.deleteDraftOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/draft-orders/{draftOrderId}',
    pathParams: { draftOrderId: 'draftOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryDraftOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.QueryDraftOrdersRequest,
  ambassadorWixEcomV1DraftOrderTypes.QueryDraftOrdersRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.QueryDraftOrdersResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.QueryDraftOrdersResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.QueryDraftOrdersResponse &
    ambassadorWixEcomV1DraftOrderTypes.QueryDraftOrdersResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.queryDraftOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/draft-orders/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setTaxExemption(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetTaxExemptionRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetTaxExemptionRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetTaxExemptionResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetTaxExemptionResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetTaxExemptionResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetTaxExemptionResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setTaxExemption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-tax-exemption',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setBusinessLocation(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBusinessLocationRequest,
  ambassadorWixEcomV1DraftOrderTypes.SetBusinessLocationRequest,
  ambassadorWixEcomV1DraftOrderUniversalTypes.SetBusinessLocationResponse &
    ambassadorWixEcomV1DraftOrderUniversalTypes.SetBusinessLocationResponseNonNullableFields,
  ambassadorWixEcomV1DraftOrderTypes.SetBusinessLocationResponse &
    ambassadorWixEcomV1DraftOrderTypes.SetBusinessLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1DraftOrder.setBusinessLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/draft-orders/set-business-location',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
